import script from "./PanelizationPropositionPanelDisplayByTruck.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelizationPropositionPanelDisplayByTruck.vue?vue&type=script&setup=true&lang=js"

import "./PanelizationPropositionPanelDisplayByTruck.vue?vue&type=style&index=0&id=1c4574ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4574ec"]])

export default __exports__